import { render, staticRenderFns } from "./config027-socket-w1.vue?vue&type=template&id=0f5c92c1&"
import script from "./config027-socket-w1.vue?vue&type=script&lang=js&"
export * from "./config027-socket-w1.vue?vue&type=script&lang=js&"
import style0 from "./config027-socket-w1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports